import React from "react";
import { Link } from "react-router-dom";
import { menuLinks, business } from "../../mock";
import { Instagram, Phone, Mail, ExternalLink, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#0d0d0d] text-white pt-20 pb-10">
      <div className="max-w-[1700px] mx-auto px-6 md:px-10">
        <div className="flex flex-col items-center text-center border-b border-white/10 pb-16">
          <Link to="/" onClick={() => window.scrollTo({ top: 0 })} aria-label="Home" className="mb-6">
            <img src="/logo-white.png" alt="Capital Corner" className="h-9 w-auto" />
          </Link>
          <p className="text-white/50 text-[13px] max-w-md leading-relaxed mb-8">
            Capital Corner Group &mdash; luxury real estate across {business.area}, delivering record-setting results and discreet, personalized service.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mb-8 text-white/70 text-[13px]">
            <a href={`tel:${business.contactPhone}`} className="flex items-center gap-2 hover:text-[#b4936a] transition-colors"><Phone size={15} /> {business.contactPhone}</a>
            <a href={`mailto:${business.email}`} className="flex items-center gap-2 hover:text-[#b4936a] transition-colors"><Mail size={15} /> {business.email}</a>
          </div>
          <p className="text-white/40 text-[12px] mb-6">{business.address}</p>
          <a href={business.instagram} target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-[#b4936a] transition-colors flex items-center gap-2" aria-label="Instagram">
            <Instagram size={20} strokeWidth={1.4} /> <span className="text-[11px] tracking-luxe uppercase">{business.instagramHandle}</span>
          </a>
          <a href={business.zillow} target="_blank" rel="noopener noreferrer" className="mt-4 text-white/50 hover:text-[#b4936a] transition-colors flex items-center gap-2" aria-label="Zillow">
            <ExternalLink size={16} strokeWidth={1.4} /> <span className="text-[11px] tracking-luxe uppercase">View Our Listings on Zillow</span>
          </a>
          <a href={business.google} target="_blank" rel="noopener noreferrer" data-testid="footer-google-link" className="mt-3 text-white/50 hover:text-[#b4936a] transition-colors flex items-center gap-2" aria-label="Google Business Profile">
            <MapPin size={16} strokeWidth={1.4} /> <span className="text-[11px] tracking-luxe uppercase">Find Us on Google</span>
          </a>
        </div>

        <nav className="flex flex-wrap justify-center gap-x-8 gap-y-4 py-12">
          {menuLinks.map((link) => (
            <Link key={link.label} to={link.to} className="text-[11px] tracking-luxe uppercase text-white/60 hover:text-white transition-colors">
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 border-t border-white/10">
          <p className="text-white/40 text-[11px] tracking-luxe-sm uppercase">&copy; 2025 Capital Corner. All Rights Reserved.</p>
          <p className="text-white/40 text-[11px] tracking-luxe-sm uppercase">Luxury Real Estate &middot; Washington Capital Region</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
